import React, { useEffect } from "react";
import { Modal, Form, Input } from "antd";

const ModalFormComponent = ({ visible, loading, data, onCancel, onCreate, form }) => {
  const { getFieldDecorator, setFieldsValue } = form;

  useEffect(() => {
    setFieldsValue({
      stringId: data?.stringId,
      value: data?.value
    });
  }, [data?.value]);

  return (
    <Modal
      visible={visible}
      title="Content Keys"
      okText="Submit"
      confirmLoading={loading}
      onCancel={onCancel}
      onOk={onCreate}
    >
      <Form onSubmit={(e) => this.handleSubmit(e)} layout="vertical">

        <Form.Item label="Key">
          {getFieldDecorator("stringId", {
            rules: [{
              required: true,
              message: 'Required!'
            }]
          })(<Input />)}
        </Form.Item>

        <Form.Item label="Text">
          {getFieldDecorator('value', {
            rules: [{
              required: true,
              message: 'Required!'
            }]
          })(
            <Input type="textarea" />
          )}
        </Form.Item>

      </Form>
    </Modal>
  );
};

const ModalForm = Form.create({ name: "modal_form" })(ModalFormComponent);

export default ModalForm;
